<template>

  <t-dialog-form :generalErrors="generalErrors" :title="title" large :ok-text="okText" @show="showModal"
                 @hidden="resetModal" :status="status" :id="id" :command="command"
                 ref="dialog_form" @onSubmit="onSubmit">


    <template #default="{status}">

      <b-card-title>{{ reference }}</b-card-title>


      <t-input-person customer :status="status" @onResume="onCustomer" :command="command" required :add-error="error.customerId"
                      v-model="form.customerId"/>

      <b-link @click="importAddressCustomer()" v-if="accountModule !== 'estate'">Importar endereço do cliente</b-link>


      <e-address :address="form.address" :not-required="accountModule !== 'estate'" :command="command" :status="status"
                 @getApi="getEmbedAddressApi"/>

      <b-row>

        <t-input v-model="form.title" cols="9" :add-error="error.title" label="Título"
                 required/>

        <t-input
            cols="3"
            v-model="form.otherCodeLabel"
            :add-error="error.otherCodeLabel"
            label="Cód. Interno"
            help="Utilize este campo caso desejar armazenar o código deste empreendimento de outro sistema seu como por exemplo o ERP da sua empresa"/>

      </b-row>

      <div  v-if="accountModule !== 'estate'">

        <b-card-title class="mt-2">Dados do Contato</b-card-title>

        <b-row>

          <t-input cols="8" label="Nome" v-model="form.contact.name"/>
          <t-input cols="4" label="Cargo" v-model="form.contact.department"/>

        </b-row>

        <b-row>

          <t-input cols="4" tel label="Tel" v-model="form.contact.tel"/>
          <t-input cols="4" email label="Email" v-model="form.contact.email"/>
          <t-input cols="4" label="Obs." v-model="form.contact.note"/>

        </b-row>


      </div>


    </template>


  </t-dialog-form>

</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";
import eAddress from "@/views/embed/general/e-address";
import ui from "@/assets/scripts/ui";
import CustomerService from "@/services/modules/customer/Customer.service";
import functionsMixins from "@/mixins/page/functionsMixins";

export default {
  name: "EnterpriseImportDialog",
  components: {tDialogForm, eAddress},
  mixins: [pageDialogFormMixin, functionsMixins],
  data() {
    return {
      id: "modal-enterprise-import",
      title: "Importação de Empreendimento",
      okText: "Importar Empreendimento",
      form: {
        enterpriseId: 0,
        title: "",
        customerId: 0,
        otherCodeLabel: "",
        contact: {
          name: "",
          department: "",
          tel: "",
          email: "",
          note: "",
        },
        address: {
          /*Embed Address version: 1.0*/
          country: "BR",
          zipcode: "",
          street: "",
          number: "",
          complement: "",
          neighborhood: "",
          provinceAbbreviation: "",
          cityId: 0
          /*-------------------------*/
        },
      },
      error: {//Campos que podem receber retorno de erro do backend
        title: "",
        otherCodeLabel: "",
      },
      addContact: false,
      accountModule: "",
      customer: {},
    }
  },
  methods: {

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    showModal() {

      //Limpa os campos
      this.resetModal()

      //Setar alguma informações padrão por exemplo vindo de fora

      if(this.accountModule === 'estate'){
        this.title = "Importação de Imóvel"
        this.okText = "Importar Imóvel"
      }

    },

    async onSubmit() {

      this.form.enterpriseId = this.foreignKey

      await this.setInsertDialog("place/enterprise/import", (item) => {
        this.itemInserted = item
        this.successInsert()
      })

    },

    async importAddressCustomer() {

      if (this.form.customerId > 0) {

        if (this.form.address.street !== '') {
          ui.msgConfirm(this, 'Confirmação de importação de endereço', 'Tem certeza que seja importar os dados?<br />Obs.: Os dados atuais de endereço serão substituidos.', async () => {
            await this.importAddressCustomerAux()
          })
        } else {
          await this.importAddressCustomerAux()
        }

      } else {

        ui.msgError(this, 'Selecione um cliente antes de tentar importar o endereço')

      }

    },

    async importAddressCustomerAux() {

      await CustomerService.getResume('id', this.form.customerId).then(resume => {

        this.form.address.street = resume.street
        this.form.address.number = resume.number
        this.form.address.neighborhood = resume.neighborhood
        this.form.address.cityId = resume.cityId
        this.form.address.complement = resume.complement
        this.form.address.zipcode = resume.zipcode
        this.form.address.provinceAbbreviation = resume.provinceAbbreviation


      }).catch(error => {

        if (error.response) {
          if (error.response.status === 500) {
            ui.msg(this, 'Informação', error.response.data.message)
          }
        } else if (error !== '') {
          ui.msg(this, "Erro", error)
        }
      })

    },

    onCustomer(v){

      this.customer = v

      if(this.form.contact.name === '' && this.objValid(this.customer.contactName)){
        this.form.contact.name = this.customer.contactName
      }

      if(this.form.contact.department === '' && this.objValid(this.customer.contactDepartment)){
        this.form.contact.department = this.customer.contactDepartment
      }

      if(this.form.contact.email === '' && this.objValid(this.customer.contactEmail)){
        this.form.contact.email = this.customer.contactEmail
      }

      if(this.form.contact.tel === '' && this.objValid(this.customer.whatsapp)){
        this.form.contact.tel = this.customer.whatsapp
      }

      if(this.form.title === '' && this.objValid(this.customer.name)){
        this.form.title = this.customer.name
      }

      if(this.form.otherCodeLabel === '' && this.objValid(this.customer.otherCodeLabel)){
        this.form.otherCodeLabel = this.customer.otherCodeLabel
      }

    }

  },

  async mounted() {

    this.accountModule = ui.getAccountModule()

  },
  props: {
    reference: String,
  },
  watch: {
    'form.address': {
      handler(val) {

        if(this.accountModule === 'estate'){

          // Verifica se houve preenchimento de street e number
          if (val.street.trim() !== "" && val.number.trim() !== "") {
            this.form.title = `${val.street}, ${val.number}`;

            // Se houver complemento, adiciona com hífen
            if (val.complement.trim() !== "") {
              this.form.title += ` - ${val.complement}`;
            }
          } else {
            // Reseta o title se não tiver os campos principais
            this.form.title = "";
          }

        }

      },
      deep: true
    }
  }
}
</script>
